import React, { createContext, useContext, useState } from "react";
import { notificationMessages } from "./notificationMessages";
import Notification from "./Notification";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const localStorageKey = 'notification';

    const [notificationsEnabled, setNotificationsEnabled] = useState(() => {
        const stored = localStorage.getItem(localStorageKey);
        return stored ? JSON.parse(stored).notification : true;
    });

    const [activeNotifications, setActiveNotifications] = useState([]);

    const toggleNotifications = () => {
        const newSetting = !notificationsEnabled;
        setNotificationsEnabled(newSetting);
        localStorage.setItem(localStorageKey, JSON.stringify({ notification: newSetting }));
    };

    const triggerNotification = (id) => {
        if (!notificationsEnabled) return;
    
        const notif = notificationMessages.find((n) => n.id === id);
        if (!notif) return;
    
        const uniqueId = Date.now() + Math.random();
        const notificationWithMeta = { ...notif, uniqueId, isVisible: true };
    
        setActiveNotifications((prev) => [notificationWithMeta, ...prev]);
    
        // Step 1: Hide it after 5s
        setTimeout(() => {
            setActiveNotifications((prev) =>
                prev.map((n) =>
                    n.uniqueId === uniqueId ? { ...n, isVisible: false } : n
                )
            );
        }, 5000);
    
        // Step 2: Remove it after 5.5s
        setTimeout(() => {
            setActiveNotifications((prev) =>
                prev.filter((n) => n.uniqueId !== uniqueId)
            );
        }, 5500);
    };

    return (
        <NotificationContext.Provider value={{
            triggerNotification,
            notificationsEnabled,
            toggleNotifications,
        }}>
            {children}

            {/* Notification Stack Container */}
            {notificationsEnabled && activeNotifications.length > 0 && (
                <div className="fixed top-4 right-4 flex flex-col gap-3 z-50">
                    {activeNotifications.map((notification) => (
                        <Notification
                            key={notification.uniqueId}
                            type={notification.type}
                            message={notification.message}
                            linkText={notification.linkText}
                            isVisible={notification.isVisible}
                        />
                    ))}
                </div>
            )}
        </NotificationContext.Provider>
    );
};
